
/**
 * Utility to map keys based on keyboard layout for IP input fields.
 * Handles auto-mapping of "shifted" digit keys (AZERTY) and special characters.
 */

const AZERTY_DIGIT_MAP = {
    '&': '1',
    'é': '2',
    '"': '3',
    '\'': '4',
    '(': '5',
    // '-': '6', // Handle conditionally in getMappedKey
    'è': '7',
    '_': '8',
    'ç': '9',
    'à': '0',
    '!': '/',
    ')': '-',
};

export const getMappedKey = (key, charBeforeCursor = null) => {
    const layout = (typeof window !== 'undefined' && window.currentKeyLayout)
        ? window.currentKeyLayout.toLowerCase()
        : 'unknown';

    // 1. Map '!' to '/'
    if (key === '!') {
        return '/';
    }

    // Special handling for '-' mapping to '6' on AZERTY
    if (key === '-' && layout.startsWith('fr')) {
        if (charBeforeCursor === ' ') {
            return null; // Don't map, let it be '-'
        }
        return '6';
    }

    // 2. Map AZERTY digit row characters to digits
    if (layout.startsWith('fr') && AZERTY_DIGIT_MAP[key]) {
        return AZERTY_DIGIT_MAP[key];
    }

    // 3. Ambiguous key ';'
    if (key === ';') {
        if (layout.startsWith('fr')) {
            return '.';
        }
        if (layout.startsWith('en')) {
            return ':';
        }
    }

    return null;
};
